module.exports = __webpack_public_path__ + "media/images/users/registrations/flow-4-49ac23e8234a534303195e14a3f24d32.png";